import "./Registration.scss";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { ToastFailure, ToastSuccess } from "../../Utils/Toast/ToastMsg";
import { useLocation, useNavigate } from "react-router-dom";

const Registration = () => {
  const location = useLocation();
  const employee = location.state?.employee || {};
  const navigate = useNavigate()

  const AddEventSchema = Yup.object().shape({
    firstName: Yup.string()
      .trim()
      .matches(/^[a-zA-Z]+([ ]?[a-zA-Z]+)*$/, "Please enter a valid first name")
      .required("Required"),
    lastName: Yup.string()
      .trim()
      .matches(/^[a-zA-Z]+([ ]?[a-zA-Z]+)*$/, "Please enter a valid last name")
      .required("Required"),
    empId: Yup.string()
      .matches(
        /^[0-9]+$/,
        "Please enter a valid ID without any spaces, alphabets, or special characters."
      )
      .required("Required"),
    email: Yup.string()
      .email("Please enter a valid email")
      .required("Email is required"),
    shiftInTime: Yup.string().required("Shift-In Time is required"),
    shiftOutTime: Yup.string().required("Shift-Out Time is required"),
  });

  const submitAPI = async (values, resetForm) => {
    const obj = {
      first_name: values.firstName,
      last_name: values.lastName,
      employee_id: "TVE-" + values.empId,
      email: values.email,
      profile_image: "empty.png",
      inTime: values.shiftInTime,
      outTime: values.shiftOutTime,
    };
    
    const obj1 = {
      first_name: values.firstName,
      last_name: values.lastName,
      employee_id: "TVE-" + values.empId,
      inTime: values.shiftInTime,
      outTime: values.shiftOutTime,
    };

    try {
      if (employee.id) {
        const response = await axios.put(`${process.env.REACT_APP_API}/api/employee`, obj1);
        if (response.status >= 200 && response.status < 300) {
          ToastSuccess("Employee updated successfully.");
          navigate('/attendances')
        }
      } else {
        const response = await axios.post(`${process.env.REACT_APP_API}/api/employee`, obj);
        if (response.status >= 200 && response.status < 300) {
          const subjectName =
            obj.first_name + "_" + obj.last_name + "_" + obj.employee_id;
          addSubjectAPI(subjectName, resetForm);
        }
      }
    } catch (error) {
      ToastFailure("Something went wrong or user already exists.");
    }
  };

  const addSubjectAPI = async (subjectName, resetForm) => {
    const config = {
      headers: {
        "content-type": "application/json",
        "x-api-key": `${process.env.REACT_APP_REGISTRATION_IMAGE_TOKEN}`,
      },
    };
    await axios
      .post(
        `${process.env.REACT_APP_API_IMAGE_CAPTURE}/api/v1/recognition/subjects`,
        { subject: subjectName },
        config
      )
      .then((response) => {
        if (response.status >= 200 && response.status < 300) {
          ToastSuccess("Employee added successfully.");
          resetForm();
        }
      })
      .catch((error) => {
        ToastFailure("Something went wrong or user already exists.");
      });
  };

  return (
    <div>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="registrationSection">
              <Formik
                initialValues={{
                  firstName: employee.first_name || "",
                  lastName: employee.last_name || "",
                  empId: employee.employee_id ? employee.employee_id.replace("TVE-", "") : "",
                  email: employee.email || "",
                  shiftInTime: employee.inTime || "",
                  shiftOutTime: employee.outTime || "",
                }}
                enableReinitialize={true}
                validationSchema={AddEventSchema}
                onSubmit={(values, { resetForm }) => {
                  submitAPI(values, resetForm);
                }}
              >
                {({
                  errors,
                  touched,
                  handleChange,
                  values,
                  isValid,
                  dirty,
                }) => (
                  <Form>
                    <div className="registerForm">
                      <div className="registrationDiv">
                        <div className="fields">
                          <label>First Name</label>
                          <br />
                          <input
                            id="firstName"
                            type="text"
                            name="firstName"
                            onChange={handleChange}
                            value={values.firstName}
                            disabled={!!employee.id} 
                          />
                          {errors.firstName && touched.firstName ? (
                            <div className="errorMsgs">
                              {errors.firstName}
                            </div>
                          ) : null}
                        </div>
                        <div className="fields">
                          <label>Last Name</label>
                          <br />
                          <input
                            id="lastName"
                            type="text"
                            name="lastName"
                            onChange={handleChange}
                            value={values.lastName}
                            disabled={!!employee.id}
                          />
                          {errors.lastName && touched.lastName ? (
                            <div className="errorMsgs">{errors.lastName}</div>
                          ) : null}
                        </div>
                        <div className="fields">
                          <label>Employee ID </label>
                          <div className="tveDiv">
                            <p>TVE-</p>
                            <input
                              id="empId"
                              type="text"
                              name="empId"
                              onChange={handleChange}
                              value={values.empId}
                              disabled={!!employee.id}
                            />
                            {errors.empId && touched.empId ? (
                              <div className="errorMsgs">{errors.empId}</div>
                            ) : null}
                          </div>
                        </div>
                        <div className="fields">
                          <label>Email</label>
                          <br />
                          <input
                            id="email"
                            type="text"
                            name="email"
                            onChange={handleChange}
                            value={values.email}
                            disabled={!!employee.id} 
                          />
                          {errors.email && touched.email ? (
                            <div className="errorMsgs">{errors.email}</div>
                          ) : null}
                        </div>
                        <div className="fields">
                          <label>Shift-In Time</label>
                          <br />
                          <input
                            id="shiftInTime"
                            type="text"
                            name="shiftInTime"
                            onChange={handleChange}
                            value={values.shiftInTime}
                          />
                          {errors.shiftInTime && touched.shiftInTime ? (
                            <div className="errorMsgs">{errors.shiftInTime}</div>
                          ) : null}
                        </div>
                        <div className="fields">
                          <label>Shift-Out Time</label>
                          <br />
                          <input
                            id="shiftOutTime"
                            type="text"
                            name="shiftOutTime"
                            onChange={handleChange}
                            value={values.shiftOutTime}
                          />
                          {errors.shiftOutTime && touched.shiftOutTime ? (
                            <div className="errorMsgs">{errors.shiftOutTime}</div>
                          ) : null}
                        </div>
                      </div>
                      <div className="employeBtn registerBtnSec">
                        <button
                          className="LogBtn"
                          type="submit"
                          disabled={!(dirty && isValid)}
                        >
                          {employee.id ? "Update" : "Submit"}
                        </button>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Registration;
